import jwtDecode from "jwt-decode";
import {InitSession} from './utils/SessionTracker'
import {auth} from "./utils/auth";
import {api } from "./utils/api";

import { INACTIVE_AUTHORIZED_TIME } from "./utils/constants";

export const init = (store) => {
    const token = localStorage.getItem("token");
    const accessToken = token && jwtDecode(JSON.parse(token).access_token)

    InitSession.configure({
        idleLifetime: INACTIVE_AUTHORIZED_TIME,
        logout: () => {
            api.logout();
        },
    });

    if(accessToken){
        InitSession.start(accessToken.exp);
    }

    if(auth.isAuthenticated() && InitSession.isExpired()){
        return api.refreshToken().then(() => {
            InitSession.start(accessToken.exp);
        })

    }else{
        return Promise.resolve()
    }

};

